import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginUser, googleLoginUser } from "../services/userAuth.service";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../../firebase";

export default function Login() {
  const navigate = useNavigate();


  useEffect(() => {
  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    navigate("/user/dashboard", { replace: true });
  }
}, [navigate]);


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // ================= NORMAL LOGIN =================
  const handleLogin = async () => {
    if (!email || !password) {
      return toast.error("Email and password required");
    }

    try {
      setLoading(true);

      const res = await loginUser(email.trim(), password.trim());

      if (res?.status === true && res?.user) {
        localStorage.setItem("userId", res.user._id);
        localStorage.setItem("user", JSON.stringify(res.user));

        toast.success(res.message || "Login successful");
        navigate("/user/dashboard", { replace: true });
      } else {
        toast.error(res?.message || "Login failed");
      }
    } catch {
      toast.error("Login failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= GOOGLE LOGIN =================
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const res = await googleLoginUser({
        email: user.email,
        identity: user.uid,
       });

      if (res?.status === true && res?.user) {
        localStorage.setItem("userId", res.user._id);
        localStorage.setItem("user", JSON.stringify(res.user));

        toast.success(res.message || "Login successful");
        navigate("/user/dashboard", { replace: true });
      } else {
        toast.error(res?.message || "Google login failed");
      }
    } catch (err) {
      toast.error("Google login failed");
    }
  };

  return (
    <div style={page}>
      <div style={card}>
        <h2 style={{ marginBottom: 20, textAlign: "center" }}>
          Login to ShareVideo
        </h2>

        <input
          style={input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          style={input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {/* NORMAL LOGIN BUTTON */}
        <button style={btn} onClick={handleLogin} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>

        {/* GOOGLE LOGIN BUTTON */}
        <button
          style={{ ...btn, marginTop: 10, background: "#4285F4" }}
          onClick={handleGoogleLogin}
        >
          Continue with Google
        </button>

        <p style={{ marginTop: 15, textAlign: "center" }}>
          New here?{" "}
          <span style={link} onClick={() => navigate("/register")}>
            Create account
          </span>
        </p>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const page = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f5f6fa",
};

const card = {
  width: 360,
  padding: 25,
  background: "#fff",
  borderRadius: 10,
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
};

const input = {
  width: "100%",
  padding: 10,
  marginBottom: 12,
  borderRadius: 6,
  border: "1px solid #ddd",
};

const btn = {
  width: "100%",
  padding: 12,
  borderRadius: 6,
  border: "none",
  background: "#ff4d67",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
};

const link = {
  color: "#ff4d67",
  cursor: "pointer",
};
